import { Navigate, Outlet } from 'react-router';
import { useAppStateContext } from '../hooks';

export const AuthProtectedRoute = () => {
  const { appState } = useAppStateContext();

  const isValidatePlayer = Boolean(appState?.tid);
  const isDeviceRegistered =
    Boolean(appState?.deviceInfo?.accessToken) && isValidatePlayer;

  if (isDeviceRegistered) {
    return <Navigate to="/" replace />;
  }

  if (isValidatePlayer) {
    return <Navigate to="/device/config" replace />;
  }

  // Only allow auth routes
  return <Outlet />;
};
